import React from 'react';
import { Button } from '@els/els-react--button';

function GSFNButton({ onClick }) {
  return (
    <Button data-e2e="insert-structure-from-name" type="tertiary" onClick={onClick} className="e2e-insert-structure-from-name">
      Insert structure from name
    </Button>
  );
}

export default GSFNButton;
